module.exports = __webpack_public_path__ + "static/media/wizualizacja-68.f0546502.png";